module.exports = __webpack_public_path__ + "img/travel.11502e97.svg";